import { render, staticRenderFns } from "./ThemeName.vue?vue&type=template&id=78df70cb&scoped=true&"
import script from "./ThemeName.vue?vue&type=script&lang=js&"
export * from "./ThemeName.vue?vue&type=script&lang=js&"
import style0 from "./ThemeName.vue?vue&type=style&index=0&id=78df70cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78df70cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78df70cb')) {
      api.createRecord('78df70cb', component.options)
    } else {
      api.reload('78df70cb', component.options)
    }
    module.hot.accept("./ThemeName.vue?vue&type=template&id=78df70cb&scoped=true&", function () {
      api.rerender('78df70cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/samurai/Themes/components/ThemeName.vue"
export default component.exports